import React, { Component } from 'react';
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import PropTypes from 'prop-types';
import SnackStore from '../../stores/SnackStore';
import FuseConfirmationModal from '../ConfirmationModal/FuseConfirmationModal';
import FuseConsoleModal from '../ConsoleModal/FuseConsoleModal';
import { Card } from '../Fuse';
import FuseButton from '../FuseControls/FuseButton';
import PreviewController from './PreviewController';

class BaseCustomizeEditModal extends Component {
    static propTypes = {
        snack: SnackStore.PropType.isRequired,
        store: MobxPropTypes.observableObject,
        noPreview: PropTypes.bool,
    };

    submit = () => {
        const { store, snack } = this.props;
        store.update()
            .then(() => snack.showSuccess(<span><b>{store.metadata.name}</b> has been saved</span>))
            .catch((e) => e && snack.showError(
                <span>Failed to save <b>{store.metadata.name}</b> options. {e.message}</span>));
    }

    render() {
        const { store, children } = this.props;
        return <FuseConsoleModal
            isOpen={store.editModal.isOpen}
            onClose={store.closeEditModal}
            title={`Edit ${store.metadata.name}`}
            headerActions={<FuseButton
                style={{ minWidth: 100 }}
                color="green"
                primary
                disabled={!store.hasChanged() || !store.isValid()}
                loading={store.updateStatus.isLoading}
                onClick={this.submit}
                qa="customize-ui-edit-modal-save-button"
            >Save</FuseButton>}
        >
            {children}
            {this.props.noPreview ? null : <Card title="Preview">
                <PreviewController store={store} />
            </Card>}
            <FuseConfirmationModal
                store={store.exitConfirmationModal}
                onConfirm={() => {
                    store.editModal.close();
                    store.resetToOriginal();
                }}
            />
        </FuseConsoleModal>;
    }
}

export default inject('snack')(observer(BaseCustomizeEditModal));
